import { Component, Input } from '@angular/core';

@Component({
  selector: 'menu-group',
  standalone: true,
  templateUrl: './menu-group.component.html',
  styleUrls: ['./menu-group.component.scss'],
})
export class MenuGroupComponent {
  @Input() public label: any;

  constructor() {}
}
